import { Queue } from "./Queue.js";
import nextTick from "./nextTick.js";
const LONG_TASK_DURATION = 40;
class SmartQueue extends Queue {
  waiter = nextTick;
  constructor() {
    super(Number.POSITIVE_INFINITY, nextTick);
  }
  flush() {
    this.run(this.tasks);
    this.isScheduled = false;
    if (this.tasks.length > 0) {
      this.scheduleFlush();
    }
  }
  run(tasks) {
    let task;
    const start = performance.now();
    let now = start;
    while (now - start < LONG_TASK_DURATION && (task = tasks.shift())) {
      task();
      now = performance.now();
    }
  }
}
export {
  SmartQueue
};
//# sourceMappingURL=SmartQueue.js.map
